<template>
  <div id="chooseMapel">
    <div class="row">
      <div v-if="selectedMapel" class="col-md-4">
        <img class="mapel-picture" v-bind:src="selectedMapel.picture"> {{ selectedMapel.nama }}
      </div>
      <div class="col-md-8">
        <button type="button" class="btn btn-success" @click="showMapels()" v-if="$store.state.tryout.status != 'PUBLISHED'">Pilih ...</button>
      </div>
    </div>
    <transition name="fade">
      <app-spinner v-if="isLoading"></app-spinner>
    </transition>
    <transition name="modal" v-if="showMapelModal">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div id="mapelModal" class="modal-container">
            <div class="modal-header ">
              <h3>Pilih Mata Pelajaran</h3>
            </div>
            <div class="modal-body">
              <ul class="list-group">
                <li v-bind:key="mapel.id" v-for="(mapel, index) in mapels" class="list-group-item" @click="selectMapel(index)">
                  <img class="mapel-picture" v-bind:src="mapel.picture"> {{ mapel.nama }}
                </li>
              </ul>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" @click="showMapelModal = false">Tutup</button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<style>
li.list-group-item:hover {
  cursor: pointer;
  background-color: #00ff99;
}

.mapel-picture {
  float: left;
  width: 45px;
  height: 34px;
  -webkit-border-radius: 50px;
  -moz-border-radius: 50px;
  border-radius: 50px;
  overflow: hidden;
  margin: -2px 10px -2px 0;
}

#mapelModal {
  width: 50%;
}
</style>
<script>
import ItembankService from '@/services/itembank.js'
import Spinner from '@/components/plugins/Spinner'

export default
{
  name: 'app-choosemapel',
  components: {
    'app-spinner': Spinner
  },
  data: function() {
    return {
      selectedMapel: null,
      isLoading: false,
      showMapelModal: false,
      mapels: []
    }
  },
  methods: {
    showMapels: function() {
      var context = this
      context.isLoading = true
      ItembankService.getListMataPelajaran(function(result) {
        if (result.success) {
          context.mapels = result.data
          context.showMapelModal = true
        }

        context.isLoading = false
      })
    },
    selectMapel: function(index) {
      this.selectedMapel = this.mapels[index]
      this.showMapelModal = false
      this.$emit('selected', this.selectedMapel)
    }
  },
  mounted: function() {
    if (this.$store.getters.selectedSubtest) {
      var mapel = {
        nama: this.$store.getters.selectedSubtest.subject_name,
        kode: this.$store.getters.selectedSubtest.subject_code,
        picture: this.$store.getters.selectedSubtest.subject_picture
      }

      this.selectedMapel = mapel
    }
  }
}
</script>



// WEBPACK FOOTER //
// ChooseMapel.vue?b0fe93cc